import { useState } from 'react'
import { authApi } from '../api/authApi'
import { accountSigninSchema, zodErrorMessage, AccountSigninInput } from '@/shared/types'
import { notify } from '@/shared/utils'

interface UseLoginOptions {
  onSuccess: () => void
}

export function useLogin({ onSuccess }: UseLoginOptions) {
  const [loading, setLoading] = useState(false)

  const login = async (input: AccountSigninInput) => {
    if (loading) return

    const result = accountSigninSchema.safeParse(input)
    if (!result.success) {
      notify.error(zodErrorMessage({ error: result.error }))
      return
    }

    try {
      setLoading(true)
      const response = await authApi.login(result.data)
      notify.success(response?.message || `OTP sent to ${input.phone}`)
      onSuccess()
    } catch (error: unknown) {
      const err = error as { message?: string }
      notify.error(err?.message || 'Failed to send OTP')
    } finally {
      setLoading(false)
    }
  }

  return { login, loading }
}
